import Crumbs from "@/components/atom/Crumbs";
import { usePathname } from "next/navigation";

export default function Header({ label }) {
  const pathaName = usePathname();
  
  return (
    <div className="flex flex-col">
      <Crumbs router={pathaName} />
      <div className="flex w-full">
        <p className="h4-semiBold text-greyscaleGON-700 capitalize">{label}</p>
      </div>
    </div>
  );
}
